import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/core/services/AuthService";
import { LoteService } from "src/app/core/services/lote.service";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import { k } from "src/environments/properties";



interface ResumenAvanceFirma {
  cantidad_total: number;
  cantidad_firmada: number;
}

interface Item {
  id: string;
  createdAt?: string;
  updatedAt: string;
  titulo: string;
  total_documentos: string;
  es_grupo: string;
  estado: string;
  firma_por_plantilla: string;
  notificacion_firmantes: string;
  plantilla_nombre: string;
  usuario: string;
}

@Component({
  selector: 'app-documentos-por-firmar',
  templateUrl: './firmas-pendientes-avance.component.html',
  styleUrls: ['./firmas-pendientes-avance.component.scss']
})
export class FirmasPendientesAvanceComponent implements OnInit {


    @ViewChild('modalGruposResumenes') modalGruposResumenes!: TemplateRef<any>;
    

  
    fullData: Item[] = []; // Tu conjunto completo de datos
    currentItems: Item[] = []; // Los datos para la página actual


    lotesPorFirmar:any[]=  [];
    totalItemsLotesPorFirmar:any = 0;

    public formSearch: FormGroup;

    currentPage: number = 1;
    pageSize: number = 10; // Tamaño de página inicial
    totalItems: number = 0;
    spinner: boolean;

    userToken:string = '';
    userId:any;

    loteSelected:any;
    modalResumenIsOpen:boolean;
    resumenAvanceFirma:any;

              
    tableHeaders = [      
      { key: 'titulo', label: 'Titulo' } ,       
      { key: 'estado', label: 'Estado' } , 
      { key: 'usuario', label: 'Usuario' } ,             
      { key: 'total_documentos', label: 'Total documentos' } , 
      { key: 'es_grupo', label: 'Es grupal' } , 
      { key: 'firma_por_plantilla', label: 'Es plantilla' } , 
      { key: 'plantilla_nombre', label: 'Plantilla' } ,       
      { key: 'notificacion_firmantes', label: 'Notificación' } ,         
      { key: 'createdAt', label: 'Fecha creación' } , 
      { key: 'updatedAt', label: 'última actualización' } ,       
    ];

    // Definición de las acciones personalizadas
    customActions: TableAction[] = [];

    constructor(
      private loteService: LoteService , 
      private fb: FormBuilder , 
      private authService: AuthService ,
      private modalService: NgbModal,
      private router: Router
    ){}

    async ngOnInit() {      

      this.formSearch = this.fb.group({
            search:  new FormControl('' , []) 
      });
      
      this.userToken = localStorage.getItem(k.token);

      if (this.userToken) {
        const dataUser = await this.authService.dataUser(this.userToken);
        this.userId  = dataUser.id;
        await this.getLotesPendientes();      
      }

       this.customActions = [
        {
          label: 'Editar',
          handler: (item: Item) => { 
            this.onGrupoClick(item);
          },
          icon: 'fa-solid fa-pen-to-square',
          colorClass: 'bg-orange',
        }
      ];       
    }


  async onGrupoClick(lote:any) {    
    this.loteSelected = lote;
    let stats = await  lastValueFrom(this.loteService.getResumenFirma( lote?.id  , null ));
    if ( stats?.body  && !this.modalResumenIsOpen  ){      
      this.modalResumenIsOpen = true;
      this.resumenAvanceFirma = stats.body;      
      this.openModal( this.modalGruposResumenes  );
    }    
  }

  
  openModal(content: any) {
    const modalRef = this.modalService.open(content, {
      centered: true,
      size: 'lg',
    });

    this.modalResumenIsOpen = true;

    modalRef.result
      .then((result) => {
        // cierre normal (modal.close)
        this.modalResumenIsOpen = false;
      })
      .catch((reason) => {
        // cerrado con X, ESC o backdrop
        this.modalResumenIsOpen = false;
      });
  }

  async search(){
    this.currentPage = 1;
    this.getLotesPendientes();
  }

  async getLotesPendientes(){    

        const {search}  =  this.formSearch.value
        this.spinner = true;
        let data =  await   lastValueFrom(this.loteService.getLotes(this.currentPage, this.pageSize ,  this.userId ,    'SDF' , search ))       
        const headers: HttpHeaders = data.headers;  
        
         this.currentItems  =  data.body.map((x:any)=>{          
          return {
            id: x.id,
            createdAt: this.formatDate(x.createdAt),
            updatedAt: this.formatDate(x.updatedAt),
            titulo: x.titulo , 
            total_documentos: x.total_documentos , 
            es_grupo:  (x.es_grupo ? 'Si' : 'No'),
            estado:   x.estado.nombre , 
            firma_por_plantilla:  (x.firma_por_plantilla ? 'Si' : 'No') ,
            notificacion_firmantes: (x.notificacion_firmantes ? 'Si':  'No'),
            plantilla_nombre: ( x?.plantilla?.nombre ) , 
            usuario: ( x?.usuario?.firstName +' '+ x?.usuario?.lastName  )
          }
        })
        this.spinner = false;
        this.totalItems = Number(headers.get('X-Total-Count'));
  }
    
  formatDate(dateStr: string): string {
    if (!dateStr) return '';

    const date = new Date(dateStr);

    return new Intl.DateTimeFormat('es-SV', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // false si quieres 24h
    }).format(date);
  }


  
  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getLotesPendientes();      
  }
  
  onPageSizeChange(newSize: number): void {      
    this.pageSize = newSize;
    this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
    this.getLotesPendientes();      
  }

  
  getProgress(resumen: ResumenAvanceFirma): number {
    if (!resumen.cantidad_total || resumen.cantidad_total === 0) {
      return 0;
    }

    return (resumen.cantidad_firmada / resumen.cantidad_total) * 100;
  }

   rederic(modulo: string) {

    switch (modulo) {
      case 'firma':
        this.router.navigate(['firmas/admin-lotes']);

        break;
      case 'plantilla':
        this.router.navigate(['firmas/admin-plantillas']);
        break;
      case 'perfil':
        this.router.navigate(['perfil/perfil']);
        break;

      case 'firmantes':
        this.router.navigate(['firmas/firmantes']);
        this.modalService.dismissAll();
        break;

      default:
           this.router.navigate([modulo]);
           this.modalService.dismissAll();
        break;
    }
  }

}